import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material';
import { useIntl } from 'react-intl';
import Select from '@mui/material/Select';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import MenuItem from '@mui/material/MenuItem';
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const ReportSelect = function ReportSelect({
  fullWidth = false,
  multiple = false,
  renderValue = null,
  items = [],
  size = 'small',
  disabled = false,
  onClickFunction = null,
  defaultValue = '',
  value = null,
  onChange,
  label = '',
  padding = '',
}) {
  const theme = useTheme();
  const intl = useIntl();

  return (
    <Select
      defaultValue={defaultValue}
      value={value}
      placeholder={`${intl.messages.SELECT} ${label}`}
      onChange={onChange}
      multiple={multiple}
      fullWidth={fullWidth}
      IconComponent={KeyboardArrowDownIcon}
      renderValue={renderValue}
      disabled={disabled}
      MenuProps={{
        PaperProps: {
          style: {
            maxHeight: 300,
          },
        },
      }}
      input={
        <OutlinedInput
          sx={{
            '& .MuiInputAdornment-root': {
              //change adornment of styled Outlined input
              borderRight: `1px solid ${theme.palette.divider}`,
              color: theme.palette.greys.main,
              padding,
              height: 'unset', //overrides root height
            },
            '& .MuiOutlinedInput-input': {
              padding: '6px',
            },
            pl: 0,
            height: '100%',
          }}
          size={size}
          startAdornment={
            <InputAdornment position="start" disablePointerEvents>
              {label}
            </InputAdornment>
          }
        />
      }
    >
      {items?.map((item) => (
        <MenuItem
          disabled={!item.active}
          key={`value-${item.value}`}
          value={item.value}
          onClick={() => {
            if (onClickFunction) onClickFunction(item.value);
          }}
        >
          {multiple && (
            <Checkbox
              checked={
                value?.find((x) => x === item.value) !== undefined &&
                value?.find((x) => x === item.value) !== null
              }
            />
          )}
          <ListItemText primary={item.label || intl.messages.NO_SELECTION} />
        </MenuItem>
      ))}
    </Select>
  );
};

ReportSelect.propTypes = {
  fullWidth: PropTypes.bool,
  label: PropTypes.string.isRequired,
  padding: PropTypes.string.isRequired,
  multiple: PropTypes.bool,
  renderValue: PropTypes.func,
  value: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.string,
    PropTypes.number,
  ]),
  onChange: PropTypes.func.isRequired,
  items: PropTypes.array,
  size: PropTypes.string,
  disabled: PropTypes.bool,
  onClickFunction: PropTypes.func,
  defaultValue: PropTypes.string,
};
export default ReportSelect;
